import * as d3 from 'd3'
export default {
  methods: {

    status_Area() {

      let canvasArea = this.canvasForm
      .append('g')
      .attr('transform',`translate(10.5, 20.5)`)

      this.area.list.forEach((d,i)=> {

        let data_ = this.rawData.find(f=> f.AREA == d.name && f.DISC == 'OVERALL' && f.CDATE == this.config.CUTOFF)

        let area = canvasArea
        .append('g')
        .attr('id', `AREA_${d.id}`)
        .attr('transform',`translate(0, ${d.y})`)

        let targetY = (i === 1 || i === 2) ? d.y - 30 : d.y
        let disc = canvasArea
        .append('g')
        .attr('id', `DISC_${d.id}`)
        .attr('transform', `translate(${d.x}, ${targetY})`)      

        area
        .append('text')
        .attr('transform',`translate(10, 0)`)
        .attr('font-size', 12).attr('fill', '#000')
        .text(d.title)

        area
        .append('text')
        .attr('transform',`translate(10, 13)`)
        .attr('font-size', 9).attr('fill', '#757575')
        .text(d.subtitle)

        let y_ = 175

        this.areaBox.forEach((b,j)=>{
          if(b.AREA != d.name) return
          
          disc
          .append('rect')
          .attr('x', 0).attr('y', y_).attr('rx', 5).attr('ry',5)
          .attr('width', 133).attr('height', 65)
          .attr('fill', '#F4F5F5').attr('stroke','#bcbcbc').attr('stroke-width', .5)
          .attr('opacity', 0.4)

          disc
          .append('text')
          .attr('transform',`translate(7, ${y_+15})`)
          .attr('font-size', 10).attr('fill', '#333')
          .text(b.DISC)          

          disc
          .append('text')
          .attr('transform',`translate(7, ${y_+27})`)
          .attr('font-size', 9).attr('fill', '#757575')
          .text(b.SUB)     

          disc
          .append('text')
          .attr('transform',`translate(7, ${y_+47})`)
          .attr('font-size', 8).attr('fill', '#757575')
          .text('Cumlative')            

          //bar
          let barLen = (120/100) * b.A_CUM
          let bColor = b.P_CUM > b.A_CUM ? '#F7BACF' : '#83D2F5'

          disc
          .append('rect')
          .attr('x', 7).attr('y', `${y_+50}`).attr('rx', 5)
          .attr('width', 120).attr('height', 8)
          .attr('fill', '#E0E0DF').attr('stroke-width', 0)                      

          disc
          .append('rect')
          .attr('x', 7).attr('y', `${y_+50}`).attr('rx', 5)
          .attr('width', barLen).attr('height', 8)
          .attr('fill', bColor).attr('stroke-width', 0)

          disc
          .append('text')
          .attr('transform',`translate(70, ${y_+32})`)
          .attr('font-size', 9).attr('fill', '#757575')
          .text('Plan')   

          disc
          .append('text')
          .attr('transform',`translate(105, ${y_+32})`)
          .attr('font-size', 9).attr('fill', '#757575')
          .text('Delta')                         

          disc
          .append('text')
          .attr('transform',`translate(90, ${y_+45})`)
          .attr('font-size', 10).attr('fill', '#757575')
          .attr('text-anchor', 'end')
          .text(b.P_CUM.toFixed(1) + '%')  

          disc
          .append('text')
          .attr('transform',`translate(33, ${y_+35})`)
          .attr('font-size', 13).attr('fill', '#333')
          .attr('text-anchor', 'end')
          .text(b.A_CUM.toFixed(1))

          disc
          .append('text')
          .attr('transform',`translate(38, ${y_+35})`)
          .attr('font-size', 12).attr('fill', '#333')
          .attr('text-anchor', 'start')
          .text('%')          
          
          disc
          .append('text')
          .attr('transform',`translate(128, ${y_+45})`)
          .attr('font-size', 10).attr('fill', this.gmx_deltaValue(b.D_CUM))
          .attr('text-anchor', 'end')
          .text(b.D_CUM.toFixed(1) + '%')           

          y_-= 68
        })
        
        let boxCount = this.areaBox.filter(b => b.AREA === d.name).length
        let yOffset = (boxCount === 2) ? 90 : 60

        this.func_TubeChart(canvasArea, d.x-this.tube.gap, d.y+yOffset, data_, i)

      })
    },

  }
}